export { default } from "./GraficaMensual";
